import slugify from '~/common/masked/slugify';

export default (rule, file) => {
  if (!file?.name || !rule?.allowedName) return true;

  const allowedName = slugify(rule.allowedName);
  const fileName = slugify(file.name.toLowerCase());
  return allowedName === fileName;
};
